import moment from 'moment'
import { createContext, useContext, useState } from 'react'
import { useDebounceValue } from 'usehooks-ts'

import { AvailabilityTypes } from '@/modules/caa/domain/models/AvailabilityTypes'
import { CAATypes } from '@/modules/caa/domain/models/CAATypes'

const caaDailyRecordsContext = createContext<{
  filter: {
    date: string
    personaName: string
    availability: AvailabilityTypes | undefined
    typeCAA: CAATypes | undefined
  }
  rawInputs: {
    personaName: string
  }
  setDate: React.Dispatch<React.SetStateAction<string>>
  setPersonaName: React.Dispatch<React.SetStateAction<string>>
  setAvailability: React.Dispatch<
    React.SetStateAction<AvailabilityTypes | undefined>
  >
  setTypeCAA: React.Dispatch<React.SetStateAction<CAATypes | undefined>>
}>({
  filter: {
    date: '',
    personaName: '',
    availability: undefined,
    typeCAA: undefined
  },
  rawInputs: {
    personaName: ''
  },
  setDate: () => {},
  setPersonaName: () => {},
  setAvailability: () => {},
  setTypeCAA: () => {}
})

export const useCAADailyRecordsContext = () =>
  useContext(caaDailyRecordsContext)

export function CAADailyRecordsProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [date, setDate] = useState<string>(
    moment().format(moment.HTML5_FMT.DATE)
  )
  const [personaName, setPersonaName] = useState<string>('')
  const [debouncedPersonaName] = useDebounceValue(personaName, 500)
  const [availability, setAvailability] = useState<
    AvailabilityTypes | undefined
  >(undefined)
  const [typeCAA, setTypeCAA] = useState<CAATypes | undefined>(undefined)

  return (
    <caaDailyRecordsContext.Provider
      value={{
        filter: {
          date,
          personaName: debouncedPersonaName,
          availability,
          typeCAA
        },
        rawInputs: {
          personaName
        },
        setDate,
        setPersonaName,
        setAvailability,
        setTypeCAA
      }}
    >
      {children}
    </caaDailyRecordsContext.Provider>
  )
}
